/**
 * Created by Andrey Popov on 03.11.2023
 *
 * https://docs.crazygames.com/sdk/html5/video-ads/
 */

const CrazyAds = function () {
    AdsPlugin.call(this, connector.CRAZY, {
        sdk: SdkManager.SDK_CRAZY,
        interstitialInterval: connector.utils.parseInterval("3 minutes")
    });

    this.alwaysRefreshSticky = true;

    this.stickyRefreshInterval = connector.utils.parseInterval("35 seconds");
};

CrazyAds.prototype = Object.create(AdsPlugin.prototype);
CrazyAds.prototype.constructor = CrazyAds;

CrazyAds.isAppropriate = function () {
    return connector.platform.oneOf(connector.CRAZY);
};

CrazyAds.prototype.isNoAdsProductAvailable = function () {
    return true;
};

CrazyAds.prototype.isStickySupported = function () {
    return true;
};

CrazyAds.prototype.checkAdBlock = function (callback) {
    CrazyGames.SDK.ad.hasAdblock()
        .then((result) => {
            callback(Boolean(result));
        })
        .catch(() => {
            callback(false);
        });
};

CrazyAds.prototype._playAd = function (name, ad, callback) {
    const adType = name === AdsPlugin.REWARDED ? "rewarded" : "midgame";

    CrazyGames.SDK.ad.requestAd(adType, {
        adStarted: function () {},
        adFinished: function () {
            callback(connector.CODE_SUCCEED);
        },
        adError: (error) => {
            const errorCode = error && (error.code || error.message);
            const code = this.parseShowError(name, errorCode);
            callback(code, [ERRORS.SHOW_REWARDED.UNKNOWN, ERRORS.SHOW_INTERSTITIAL.UNKNOWN].includes(code) ? errorCode : undefined);
        }
    });
};

CrazyAds.prototype.parseShowError = function (name, errorCode) {
    const errors = name === AdsPlugin.REWARDED ? ERRORS.SHOW_REWARDED : ERRORS.SHOW_INTERSTITIAL;

    switch (errorCode) {
        case "adCooldown":
            return errors.THROTTLED;
        case "unfilled":
            return errors.NO_ADS;
        case "adblock":
            return errors.AD_BLOCK;
        default:
            return errors.UNKNOWN;
    }
};

CrazyAds.prototype._cacheAd = function (name, callback) {
    CrazyGames.SDK.ad.hasAdblock()
        .then((result) => {
            if (result) {
                callback(AdsPlugin.ERROR_LOADING_ADBLOCK);
            } else {
                callback(connector.CODE_SUCCEED, true);
            }
        })
        .catch(() => {
            callback(AdsPlugin.ERROR_LOADING_FAILED);
        });
};

CrazyAds.prototype.showSticky = function (callback) {
    let container = document.getElementById("crazygames-ad-banner-container");

    if (!container) {
        container = document.createElement("div");
        container.id = "crazygames-ad-banner-container";
        container.style.display = "block";
        container.style.visibility = "hidden";
        container.style.position = "absolute";
        container.style.zIndex = "2";
        container.style.bottom = "0";
        container.style.left = "0";
        container.style.right = "0";
        container.style.margin = "0 auto";
        container.style.height = `${CrazyAds.AD_BANNER_HEIGHT}px`;
        container.style.width = `${CrazyAds.AD_BANNER_WIDTH}px`;
        document.body.appendChild(container);
    }

    CrazyGames.SDK.banner.requestBanner({
        id: "crazygames-ad-banner-container",
        width: CrazyAds.AD_BANNER_WIDTH,
        height: CrazyAds.AD_BANNER_HEIGHT
    })
        .then(() => {
            container.style.visibility = "visible";

            callback(connector.CODE_SUCCEED, {
                width: CrazyAds.AD_BANNER_WIDTH,
                height: CrazyAds.AD_BANNER_HEIGHT
            });
        })
        .catch((error) => {
            container.remove();
            callback(error);
        });
};

CrazyAds.prototype.refreshSticky = function (callback) {
    CrazyGames.SDK.banner.requestBanner({
        id: "crazygames-ad-banner-container",
        width: CrazyAds.AD_BANNER_WIDTH,
        height: CrazyAds.AD_BANNER_HEIGHT
    })
        .then(() => {
            callback(connector.CODE_SUCCEED);
        })
        .catch((error) => {
            callback(connector.CODE_FAILED, error);
        });
};

CrazyAds.prototype.closeSticky = function (callback) {
    CrazyGames.SDK.banner.clearAllBanners();

    const container = document.getElementById("crazygames-ad-banner-container");
    if (container) {
        container.remove();
    }

    callback(connector.CODE_SUCCEED);
};

CrazyAds.AD_BANNER_WIDTH = 320;
CrazyAds.AD_BANNER_HEIGHT = 50;
